module.exports = __webpack_public_path__ + "static/media/grant.5cbb568c.svg";